export enum ChangeableStatus {
  FOR_FREE = 'forFree',
  WITH_CHARGE = 'withCharge',
  NOT_CHANGEABLE = 'notChangeable',
}
